// Function to load scripts
function loadScripts(scripts, callback) {
  let loadedCount = 0;
  scripts = [...new Set(scripts)];
  function loadScript(url) {
    const script = document.createElement("script");
    script.src = url;
    script.onload = () => {
      loadedCount++;
      // Check if all scripts have been loaded
      if (loadedCount === scripts.length) {
        if (callback) callback(); // Call the callback if provided
      }
    };
    script.onerror = () => {
      console.error(`Error loading script: ${url}`);
      loadedCount++;
      // Check if all scripts have been loaded
      if (loadedCount === scripts.length) {
        if (callback) callback();
      }
    };
    document.head.appendChild(script);
  }

  // Load each script in the array
  scripts.forEach(loadScript);
}

document.addEventListener("DOMContentLoaded", () => {
  loadScripts(window.script_loader, () => {
    console.log("All scripts loaded successfully!");
  });
});
